import { createFileRoute } from '@tanstack/react-router';
import { PostsAndPhotosPage } from '@/features/marketing/google-ranking/posts/posts-and-photos-page';

/** Marketing › Google Ranking › Posts & photos (posts autopilot, upcoming / past posts, photos on Google). */
export const Route = createFileRoute('/_auth/$orgId/marketing/google-ranking/posts')({
  component: PostsAndPhotosPage,
});
